(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/teams-create-invite.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/teams-create-invite.js');
'use strict';

const logger = svs.arena.logger;
const {
  Form,
  ControlGroup
} = svs.ui.reactForm;
const {
  ReactButton: Button
} = svs.ui;
const Icon = svs.ui.ReactIcon;
const AmountInput = svs.ui.reactFormInputs.AmountInput;
const {
  useHistory
} = ReactRouterDOM;
const {
  fetchTeams
} = svs.arena.store.teams.actions;
const {
  routes,
  depositType
} = svs.arena.constants;
const {
  createTeamInviteId
} = svs.arena.store.teams.actions;
const {
  TeamShowLink
} = svs.arena.pages.teams.components;
const TeamsCreateInvite = _ref => {
  let {
    createdTeamId
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const history = useHistory();
  const [initialDeposit, setInitialDeposit] = React.useState('');
  const [isShowInviteLinkButtonDisabled, setIsShowInviteLinkButtonDisabled] = React.useState(false);
  const [isGotoMyTeamsButtonDisabled, setIsGotoMyTeamsButtonDisabled] = React.useState(false);
  const [showButtonInviteLink, setShowButtonInviteLink] = React.useState(true);
  const handleOnAmountChange = e => {
    logger.debug('**** handleOnAmountChange, e: ', e);
    setInitialDeposit(e.target.value);
  };
  const submitForm = async (e, formData, isValid) => {
    logger.debug('**** submitForm, e: ', e);
    e.preventDefault();
    if (isShowInviteLinkButtonDisabled) {
      return;
    }
    setIsShowInviteLinkButtonDisabled(true);
    logger.debug('submitForm, formData', formData);
    logger.debug('submitForm, isValid', isValid);
    if (!isValid) {
      setIsShowInviteLinkButtonDisabled(false);
      return;
    }
    logger.debug('OK! lets submitForm :)');
    const trackTeamLink = {
      category: 'spela-tillsammans',
      action: 'new_team_show_link',
      opt_label: 'yes'
    };
    svs.components.analytics.trackEvent(trackTeamLink);
    svs.arena.logger.debug('TeamInviteLink, createNewLink, teamId:', createdTeamId);
    const deposit = initialDeposit && initialDeposit > 0 ? initialDeposit : 0;
    const trackRecommendedDeposit = {
      category: 'spela-tillsammans',
      action: 'recommended_deposit',
      opt_label: deposit === 0 ? 'no' : 'yes'
    };
    svs.components.analytics.trackEvent(trackRecommendedDeposit);
    const linkData = await dispatch(createTeamInviteId({
      teamId: createdTeamId,
      initialDeposit: deposit
    }));
    svs.arena.logger.debug('TeamInviteLink, createdNewLink, linkData:', linkData);
    setShowButtonInviteLink(false);
  };
  const setDepositData = async () => new Promise(resolve => {
    svs.components.Storage.browser.set('syndicateDepositAmount', 'syndicate', {
      amount: initialDeposit,
      syndicateId: createdTeamId,
      depositType: depositType.CREATE
    }, svs.components.Storage.constants.EXPIRES_10M, () => {
      resolve();
    });
  });
  const handleButtonGotoTeam = async () => {
    var _teamsNew$payload;
    if (isGotoMyTeamsButtonDisabled) {
      logger.debug('**** handleButtonGotoTeam, setIsGotoMyTeamsButtonDisabled: ', setIsGotoMyTeamsButtonDisabled);
      return;
    }
    setIsGotoMyTeamsButtonDisabled(true);
    if (initialDeposit && initialDeposit > 0) {
      await setDepositData();
    }
    const teamsNew = await dispatch(fetchTeams());
    const foundTeam = teamsNew === null || teamsNew === void 0 || (_teamsNew$payload = teamsNew.payload) === null || _teamsNew$payload === void 0 || (_teamsNew$payload = _teamsNew$payload.data) === null || _teamsNew$payload === void 0 ? void 0 : _teamsNew$payload.find(team => team.syndicateId === createdTeamId);
    logger.debug('**** handleButtonGotoTeam, teamsNew, createdTeamId, yes: ', teamsNew, createdTeamId, foundTeam);
    if (foundTeam) {
      logger.debug('**** handleButtonGotoTeam, foundTeam yes!, navigate to my teams');
      history.push(routes.TEAMS);
    } else {
      logger.debug('**** handleButtonGotoTeam, did NOT foundTeam, navigate to wait page');
      history.push({
        pathname: routes.TEAMS_WAIT_FOR_BACKEND,
        search: "?teamId=".concat(createdTeamId)
      });
    }
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "align-center"
  }, React.createElement(Icon, {
    icon: "win",
    size: "1000"
  })), React.createElement("h2", {
    className: "margin-top-2 margin-bottom-1 f-medium align-center h2"
  }, React.createElement("span", {
    className: "f-medium"
  }, "Grattis till ditt nya lag!")), React.createElement("h3", {
    className: "margin-top-0 f-medium align-center h3"
  }, React.createElement("span", {
    className: "f-medium"
  }, "Nu \xE4r det dags att bjuda in dina kompisar.")), showButtonInviteLink && React.createElement(Form, {
    id: "create-team-form",
    method: "POST",
    onSubmit: submitForm
  }, React.createElement(React.Fragment, null, React.createElement(ControlGroup, {
    infoMessage: "Ange en summa f\xF6r lagmedlemmarna att s\xE4tta in n\xE4r de g\xE5r med i laget s\xE5 att ni kan komma ig\xE5ng s\xE5 fort som m\xF6jligt.",
    v2: true
  }, React.createElement(AmountInput, {
    errorMessageDefault: "Felaktigt angivet belopp. Ange belopp i hela kronor.",
    errorMessageMax: "Det h\xF6gsta beloppet du kan ange \xE4r 1 000 kr",
    errorMessageMin: "Minsta ins\xE4ttningsbelopp \xE4r 1 kr.",
    helpMessage: "Ange belopp i kronor",
    id: "initialDepositInput",
    isCentsAllowed: false,
    isRequired: false,
    label: "Valfri rekommenderad \xF6verf\xF6ring",
    max: 1000,
    min: 0,
    name: "initialDepositInput",
    onChange: handleOnAmountChange,
    value: initialDeposit
  })), React.createElement(Button, {
    block: true,
    className: "margin-top-1",
    disabled: isShowInviteLinkButtonDisabled,
    inverted: true,
    size: 300,
    type: "submit"
  }, "Visa inbjudningsl\xE4nk"))), !showButtonInviteLink && React.createElement(React.Fragment, null, React.createElement("div", null, "H\xE4r \xE4r l\xE4nken du anv\xE4nder f\xF6r att bjuda in:"), React.createElement("div", {
    className: "margin-top-1"
  }, React.createElement(TeamShowLink, {
    isCreate: true,
    teamId: createdTeamId
  }), React.createElement(Button, {
    block: true,
    className: "margin-top-1",
    disabled: isGotoMyTeamsButtonDisabled,
    onClick: handleButtonGotoTeam,
    size: 300,
    transparent: true
  }, "G\xE5 till mina lag"))));
};
svs.arena.pages.teams.components.TeamsCreateInvite = TeamsCreateInvite;

 })(window);